import React from "react";
import ModalNew from "./ModalNew";
import { CheckCircle2, XCircle, AlertCircle } from "lucide-react";

interface StatusModalProps {
  isOpen: boolean;
  status: "success" | "error";
  title?: string;
  message: string;
  buttonText?: string;
  onAction?: () => void;
  onClose: () => void;
}

const StatusModal: React.FC<StatusModalProps> = ({
  isOpen,
  status,
  title,
  message,
  buttonText = "Continue",
  onAction,
  onClose,
}) => {
  const isSuccess = status === "success";

  const handleAction = () => {
    if (onAction) {
      onAction();
    }
    onClose();
  };

  return (
    <ModalNew isOpen={isOpen} onClose={onClose} className="max-w-[485px]">
      <div className="flex flex-col justify-center items-center text-center py-4 w-full">
        <div className="mb-4">
          {isSuccess ? (
            <CheckCircle2 className="w-16 h-16 text-green-500" />
          ) : (
            <XCircle className="w-16 h-16 text-red-500" />
          )}
        </div>

        <h2
          className={`text-2xl font-bold mb-2 ${isSuccess ? "text-gray-800" : "text-red-600"}`}
        >
          {title || (isSuccess ? "Success!" : "Failed")}
        </h2>

        <p className="text-gray-600 mb-8 whitespace-pre-wrap">{message}</p>

        <button
          onClick={handleAction}
          className={`w-full py-3 rounded-lg font-semibold text-white transition-all ${
            isSuccess
              ? "bg-green-600 hover:bg-green-700 shadow-md hover:shadow-lg"
              : "bg-red-600 hover:bg-red-700 shadow-md hover:shadow-lg"
          }`}
        >
          {buttonText}
        </button>
      </div>
    </ModalNew>
  );
};

export default StatusModal;
